<template>
  <div class="ml-3">
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <div v-on="on" style="cursor:pointer;">
          <v-avatar color="grey" size="45">
            <v-img v-if="user.photo" :src="user.photo" :alt="user.firstName" />
            <span v-else class="white--text subtitle">
              {{ user.firstName | initials }}
              {{ user.lastName | initials }}
            </span>
          </v-avatar>
          <span class="ml-2 subtitle">{{ user.firstName }}</span>
          <v-icon>mdi-menu-down</v-icon>
        </div>
      </template>
      <v-list nav dense>
        <v-subheader>{{ user.firstName }} {{ user.middleName }} {{ user.lastName }}</v-subheader>

        <v-list-item color="primary" @click="logout">
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Log ud</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item>
        <v-list-item color="primary" :to="`/profil/${user.id}`">
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Min profil</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/auth";

export default {
  props: ["user"],
  filters: {
    initials: function(value) {
      if (value) {
        let first = value.charAt(0).toUpperCase();
        return first;
      }
    }
  },
  computed: {
    /* avatar() {
      if (this.user.fornavn && this.user.efternavn) {
        return this.user.fornavn.charAt(0) + this.user.efternavn.charAt(0);
      }
      return null;
    } */
  },
  methods: {
    /* thumb(url, suffix) {
      if (url) {
        //console.log(url);
        if (!suffix) {
          suffix = '_100x100';
        }

        var filename = url
          .substring(url.lastIndexOf('%2F') + 3)
          .split('/')
          .pop()
          .split('?')[0];
        var ext = filename.split('.').pop();
        var name = filename
          .split('.')
          .slice(0, -1)
          .join('.');
        return url.replace(filename, 'thumbs%2F' + name + suffix + '.' + ext);
      }
    }, */
    initials(userData) {
      return userData.firstName.charAt(0) + userData.lastName.charAt(0);
    },
    logout() {
      console.log("logging out");
      firebase
        .auth()
        .signOut()
        .then(data => {
          this.$store.dispatch("logout");
          this.$router.replace({ path: "/" });
          console.log("sign out", data);
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
